import type { TranslationModule } from '../types';

export const commonTranslations: TranslationModule = {
  ro: {
    brand: "LegeaAplicată",
    tagline: "Legal Intelligence",
    tryFree: "Încearcă Gratuit",
    tryFreeSub: "Acces instant, fără card",
    login: "Autentificare",
    register: "Creează cont gratuit",
    home: "Acasă",
    loading: "Se încarcă...",
    error: "Eroare",
    support: "Suport",
    partner: "În parteneriat cu Institutul Național de Cercetare - Dezvoltare în Informatică",
    partnerShort: "În parteneriat cu ICI București",
    avatarDefault: "U",
    account: "Contul meu",
    guestAccount: "Cont",
    accountShort: "Cont",
    settings: "Setări profil",
    logout: "Deconectare",
    premium: "Premium",
    cases: "Dosare",
    legalAnalysis: "Analiză Juridică",
    tryNow: "Începe Gratuit",
    freeAccess: "Acces gratuit, fără card",
    apply: "Aplică",
    cancel: "Anulează",
    close: "Închide",
    searchPlaceholder: "Caută...",
    noResults: "Nu s-au găsit rezultate",
    language: "Limbă"
  },
  en: {
    brand: "LegeaAplicată",
    tagline: "Legal Intelligence",
    tryFree: "Try for Free",
    tryFreeSub: "Instant access, no card required",
    login: "Login",
    register: "Create free account",
    home: "Home",
    loading: "Loading...",
    error: "Error",
    support: "Support",
    partner: "In partnership with the National Institute for Research and Development in Informatics",
    partnerShort: "In partnership with ICI Bucharest",
    avatarDefault: "U",
    account: "My Account",
    guestAccount: "Account",
    accountShort: "Account",
    settings: "Profile Settings",
    logout: "Logout",
    premium: "Premium",
    cases: "Cases",
    legalAnalysis: "Legal Analysis",
    tryNow: "Start Free Trial",
    freeAccess: "Free access, no card required",
    apply: "Apply",
    cancel: "Cancel",
    close: "Close",
    searchPlaceholder: "Search...",
    noResults: "No results found",
    language: "Language"
  },
  fr: {
    brand: "LegeaAplicată",
    tagline: "Legal Intelligence",
    tryFree: "Essayer Gratuitement",
    tryFreeSub: "Accès instantané, sans carte",
    login: "Connexion",
    register: "Créer un compte gratuit",
    home: "Accueil",
    loading: "Chargement...",
    error: "Erreur",
    support: "Support",
    partner: "En partenariat avec l'Institut National de Recherche et Développement en Informatique",
    partnerShort: "En partenariat avec l'ICI Bucarest",
    avatarDefault: "U",
    account: "Mon Compte",
    guestAccount: "Compte",
    accountShort: "Compte",
    settings: "Paramètres de Profil",
    logout: "Déconnexion",
    premium: "Premium",
    cases: "Dossiers",
    legalAnalysis: "Analyse Juridique",
    tryNow: "Commencer Gratuitement",
    freeAccess: "Accès gratuit, sans carte requise",
    apply: "Appliquer",
    cancel: "Annuler",
    close: "Fermer",
    searchPlaceholder: "Rechercher...",
    noResults: "Aucun résultat trouvé",
    language: "Langue"
  }
};

export default commonTranslations;
